import { useLanguage } from '../i18n/LanguageContext';

export default function FreeLegalAid() {
  const { t } = useLanguage();
  const paragraphs = Array.isArray(t.freeLegalAid.paragraphs) ? t.freeLegalAid.paragraphs : [];
  const links = Array.isArray(t.freeLegalAid.links) ? t.freeLegalAid.links : [];

  return (
    <div>
      <div className="page-header documents-page">
        <h1>{t.freeLegalAid.title}</h1>

        {paragraphs.map((paragraph) => (
          <p key={paragraph}>{paragraph}</p>
        ))}

        {links.length > 0 && (
          <section className="document-section">
            <h2>{t.freeLegalAid.linksTitle}</h2>
            <ul>
              {links.map((link) => (
                <li key={link.url}>
                  <a href={link.url} target="_blank" rel="noreferrer">
                    {link.label || link.url}
                  </a>
                </li>
              ))}
            </ul>
          </section>
        )}
      </div>
    </div>
  );
}
